import React, { Component } from "react";
import {
	BrowserRouter as Router,
	Route,
	Routes,
	useNavigate,
	Navigate,
	Outlet,
} from "react-router-dom";
import LoginPage from "./components/LoginPage";
import ClusterPage from "./components/cluster/ClusterPage";
import ClusterForm from "./components/cluster/ClusterForm";
import UserManagementPage from "./components/UserManagement";
import AuthProvider, { useAuth } from "./helpers/AuthProvider";
// import AuthSuccessPage from "./components/AuthSuccessPage";

import { ThemeProvider, createTheme } from "@mui/material/styles";
import ApplicationsPage from "./components/application/ApplicationsPage";
import ServicesPage from "./components/service/ServicesPage";
import DashBoardPage from "./components/DashBoardPage";
import PageNotFound from "./helpers/PageNotFound";
import ClusterDetailsPage from "./components/cluster/ClusterDetailsPage";
import ClusterRequestsPage from "./components/cluster/ClusterRequestsPage";
import ClusterApproveFormPage from "./components/cluster/ClusterApproveFormPage";
import ApplicationRequesterForm from "./components/application/ApplicationRequesterForm";
import ApplicationApproveFormPage from "./components/application/ApplicationApproveFormPage";
import ApplicationRequestsPage from "./components/application/ApplicationRequestsPage";
import ApplicationDetailsPage from "./components/application/ApplicationDetailsPage";
import ServiceRequesterForm from "./components/service/ServiceRequesterForm";
import ServiceApproveFormPage from "./components/service/ServiceApproveFormPage";
import ServiceRequestsPage from "./components/service/ServiceRequestsPage";
import ServiceDetailsPage from "./components/service/ServiceDetailsPage";


import CustomAPICatalogue from "./components/integrations/CustomAPICatalogue";

import LandingPage from "./components/LandingPage";

import AIAgent from "./components/aisolutions/AIAgent";

import ExplorePlugins from "./components/integrations/ExplorePlugins";
import Integrations from "./components/integrations/Integrations";


import GCPCostAgent from "./components/integrations/GCPCostAgent";
import CheckovDetails from "./components/integrations/CheckovDetails";
import KyvernoDetails from "./components/integrations/KyvernoDetails";


import ExistingClusterForm from "./components/cluster/ExistingClusterForm";
import Grafana from "./components/integrations/Grafana";
import Prometheus from "./components/integrations/Prometheus";

import MirroringAppDetails from "./components/integrations/MirroringApp";
import CostDashboard from "./components/CostDashboard";
import AddAIAgentPage from "./components/aisolutions/AIAgentForm";
import AIAgentDetailsPage from "./components/aisolutions/AIAgentDetailsPage";
import AIAgentRequestsPage from "./components/aisolutions/AIAgentRequestsPage";
import AIAgentApproveFormPage from "./components/aisolutions/AIAgentApproveFormPage";

import SonarQube from "./components/integrations/SonarQube";
import NonK8sApplicationRequesterForm from "./components/application/NonK8sApplicationRequesterForm";
import ComingSoonPage from "./components/ComingSoonPage";
import DataPipelines from "./components/datasolutions/dataPipelines/DataPipelines";
import DataWarehouses from "./components/datasolutions/DataWarehouses/DataWarehouses";
import DataBI from "./components/datasolutions/DataBI/DataBI";
import GrafanaIntegrationPage from "./components/integrations/GrafanaIntegrationPage";


import AWSClusterForm from "./components/cluster/AWSClusterForm";
import Notebooks from "./components/aisolutions/Notebooks/Notebooks";

import AddNotebookPage from "./components/aisolutions/Notebooks/NotebooksForm";
import NotebooksDetailsPage from "./components/aisolutions/Notebooks/NotebooksDetailsPage";
import NotebooksRequestsPage from "./components/aisolutions/Notebooks/NotebooksRequestsPage";

import NotebooksApproveFormPage from "./components/aisolutions/Notebooks/NotebooksApproveFormPage";
import DataWarehousesForm from "./components/datasolutions/DataWarehouses/DataWarehousesForm";
import FineTuning from "./components/aisolutions/FineTuning/FineTuning";
import FineTuningForm from "./components/aisolutions/FineTuning/FineTuningForm";
import AddDataPipelinePage from "./components/datasolutions/dataPipelines/DataPipelinesForm";
import DataPipelineRequestsPage from "./components/datasolutions/dataPipelines/DataPipelinesRequests";
import DataPipelineApproveFormPage from "./components/datasolutions/dataPipelines/DataPipelinesApproverPage";
import DataPipelineDetailsPage from "./components/datasolutions/dataPipelines/DataPipelinesDetails";
import RAGPage from "./components/aisolutions/RAG/RAG";
import AddRAGPage from "./components/aisolutions/RAG/RAGForm";
import RAGDetailsPage from "./components/aisolutions/RAG/RAGDetailsPage";
import RAGRequestsPage from "./components/aisolutions/RAG/RAGRequestsPage";
import RAGApproveFormPage from "./components/aisolutions/RAG/RAGApproveFormPage";
import FineTuningDetailsPage from "./components/aisolutions/FineTuning/FineTuningDetails";
import FineTuningApproveFormPage from "./components/aisolutions/FineTuning/FineTuningApproveFormPage";
import FineTuningRequestsPage from "./components/aisolutions/FineTuning/FineTuningRequestsPage";
import DataWarehousesDetailsPage from "./components/datasolutions/DataWarehouses/DataWarehousesDetails";
import DataWarehousesApproveFormPage from "./components/datasolutions/DataWarehouses/DataWarehousesApproveFormPage";
import DataWarehousesRequestsPage from "./components/datasolutions/DataWarehouses/DataWarehousesRequestsPage";
import DataBIForm from "./components/datasolutions/DataBI/DataBIForm";
import DataBIDetailsPage from "./components/datasolutions/DataBI/DataBIDetailsPage";
import DataBIRequestsPage from "./components/datasolutions/DataBI/DataBIRequestsPage";
import DataBIApproveFormPage from "./components/datasolutions/DataBI/DataBIApproveFormPage";
import APIPage from "./components/apis/APIPage";
import APIRequesterForm from "./components/apis/APIForm";
import APIDetailsPage from "./components/apis/APIDetailsPage";
import APIRequestsPage from "./components/apis/APIRequestsPage";
import APIApproveFormPage from "./components/apis/APIApproveFormPage";
import APIGatewayPage from "./components/apis/apis-gateway/APIGatewayPage";
import APIGatewayDetailsPage from "./components/apis/apis-gateway/APIGatewayDetailsPage";
import APIGatewayForm from "./components/apis/apis-gateway/APIGatewayForm";
import APIGatewayRequestsPage from "./components/apis/apis-gateway/APIGatewayRequestsPage";
import APIGatewayApproveFormPage from "./components/apis/apis-gateway/APIGatewayApproveFormPage";
import AddExistingAPIForm from "./components/apis/AddExistingAPIForm";
import ConsumerGroupPage from "./components/apis/consumer-group/ConsumerGroupPage";
import ConsumerGroupDetailsPage from "./components/apis/consumer-group/ConsumerGroupDetailsPage";
import ConsumerGroupForm from "./components/apis/consumer-group/ConsumerGroupForm";
import ConsumerGroupRequestsPage from "./components/apis/consumer-group/ConsumerGroupRequestsPage";
import ConsumerGroupApproveFormPage from "./components/apis/consumer-group/ConsumerGroupApproveFormPage";
import ChatbotScreen from "./components/aisolutions/AIVerse";
import FullChatbot from "./components/aisolutions/AIVerse";
import AgentverseChat from "./components/aisolutions/AIVerse";
import DataSources from "./components/datasolutions/DataSources/DataSources";
import AddDataSourcesPage from "./components/datasolutions/DataSources/DataSourcesForm";
import DataSourcesDetailsPage from "./components/datasolutions/DataSources/DataSourcesDetails";
import DataSourcesRequestsPage from "./components/datasolutions/DataSources/DataSourcesRequests";
import DataSourcesApproveFormPage from "./components/datasolutions/DataSources/DataSourcesApproverPage";
import DataLakes from "./components/datasolutions/DataLakes/DataLakes";
import AddDataLakesPage from "./components/datasolutions/DataLakes/DataLakesForm";
import DataLakesDetailsPage from "./components/datasolutions/DataLakes/DataLakesDetails";
import DataLakesRequestsPage from "./components/datasolutions/DataLakes/DataLakesRequests";
import DataLakesApproveFormPage from "./components/datasolutions/DataLakes/DataLakesApproverPage";
import DataZones from "./components/datasolutions/DataZones/DataZones";
import AddDataZonesPage from "./components/datasolutions/DataZones/DataZonesForm";
import DataZonesDetailsPage from "./components/datasolutions/DataZones/DataZonesDetails";
import DataZonesRequestsPage from "./components/datasolutions/DataZones/DataZonesRequests";
import DataZonesApproveFormPage from "./components/datasolutions/DataZones/DataZonesApproverPage";
import DataScans from "./components/datasolutions/DataScans/DataScans";
import DataScansApproverPage from "./components/datasolutions/DataScans/DataScansApproverPage";
import DataScansDetails from "./components/datasolutions/DataScans/DataScansDetails";
import DataScansForm from "./components/datasolutions/DataScans/DataScansForm";
import DataScansRequests from "./components/datasolutions/DataScans/DataScansRequests";




const PrivateRoutes = ({ roles }: any) => {
	const { user } = useAuth();
	if (!user) {
		return <Navigate to="/" />;
	}
	if (roles.length > 0 && !roles.some((element: string) => user.roles?.includes(element))) {
		return <Navigate to="/page-not-found" />;
	}
	return <Outlet />;
};
const App: React.FC = () => {
	return (
		<ThemeProvider
			theme={createTheme({
				typography: {
					allVariants: {
						fontFamily: "Gilroy-Medium",
					},
				},
			})}
		>

			<Router>
				<AuthProvider>
					<Routes>
					
						<Route path="/" element={<LandingPage/>}/>
						<Route path="/login" element={<LoginPage />} />
						<Route element={<PrivateRoutes roles={[]} />}>
							<Route path="/page-not-found" element={<PageNotFound />} />
						</Route>
						
						<Route
							element={
								<PrivateRoutes roles={["cluster_owner", "application_owner", "idp_admin", "viewer"]} />
							}
						>
							<Route path="/clusters" element={<ClusterPage />} />
						</Route>
						<Route
							element={
								<PrivateRoutes
									roles={["cluster_owner", "application_owner", "idp_admin", "developer", "viewer"]}
								/>
							}
						>
							<Route path="/applications" element={<ApplicationsPage />} />
						</Route>
						<Route
							element={
								<PrivateRoutes
									roles={[
										"cluster_owner",
										"application_owner",
										"idp_admin",
										"viewer",
										"developer",
										"viewer",
										"infrastructure_admin",
									]}
								/>
							}
						>
							<Route path="/overview" element={<DashBoardPage />} ></Route>
					
				
							<Route path="/aisolutions/aiagent" element={<AIAgent/>}></Route>
							
							<Route path="/aisolutions/aiagent/add" element={<AddAIAgentPage isEdit={false} />}></Route>
							<Route path="/aisolutions/aiagent/edit/:id" element={<AddAIAgentPage isEdit={true} />}></Route>

							<Route path="/aisolutions/aiverse" element={<AgentverseChat />}></Route>

							<Route path="/aisolutions/rag" element={<RAGPage/>}></Route>
							<Route path="/aisolutions/rag/details/:id" element={<RAGDetailsPage/>}></Route>
							<Route path="/aisolutions/rag/add" element={<AddRAGPage isEdit={false} />}></Route>
							<Route path="/aisolutions/rag/edit/:id" element={<AddRAGPage isEdit={true}   />}></Route>
							<Route path="/aisolutions/requests/rag" element={<RAGRequestsPage />}></Route>
							<Route path="/aisolutions/requests/rag/:id" element={<RAGApproveFormPage />}></Route>
						
							<Route path="/aisolutions/requests/aiagent" element={<AIAgentRequestsPage/>}></Route>
							<Route path="/aisolutions/requests/aiagent/:id" element={<AIAgentApproveFormPage/>}></Route>
							
							<Route path="/aisolutions/aiagent/details/:id" element={<AIAgentDetailsPage/>} />

							<Route path="/aisolutions/finetuning" element={<FineTuning />} />
							<Route path="/aisolutions/finetuning/details/:id" element={<FineTuningDetailsPage/>} />
							<Route path="/aisolutions/finetuning/add" element={<FineTuningForm isEdit={false}/>} />
							<Route path="/aisolutions/finetuning/edit/:id" element={<FineTuningForm isEdit={true}/>} />
							<Route path="/aisolutions/requests/finetuning/:id" element={<FineTuningApproveFormPage/>} />
							<Route path="/aisolutions/requests/finetuning" element={<FineTuningRequestsPage/>} />
							<Route path="/aisolutions/notebooks" element={<Notebooks />} />
							<Route path="/aisolutions/notebooks/add" element={<AddNotebookPage isEdit={false} />} />
							<Route path="/aisolutions/notebooks/edit/:id" element={<AddNotebookPage isEdit={true} />} />
							<Route path="/aisolutions/notebooks/details/:id" element={<NotebooksDetailsPage/>} />
							<Route path="/aisolutions/requests/notebooks" element={<NotebooksRequestsPage/>} />
							<Route path="/aisolutions/requests/notebook/:id" element={<NotebooksApproveFormPage/>} />


							
							
						</Route>
						<Route
							element={<PrivateRoutes roles={["application_owner", "idp_admin", "developer", "viewer"]} />}
						>
							<Route path="/services" element={<ServicesPage />} />
						</Route>
						<Route element={<PrivateRoutes roles={["idp_admin", "viewer"]} />}>
							<Route path="/user-management" element={<UserManagementPage />} />
						</Route>
						<Route element={<PrivateRoutes roles={["idp_admin","infrastructure_admin","cluster_owner","application_owner","developer", "viewer"]} />}>
						    <Route path="/integrations" element={<Integrations/>}></Route>
							<Route path="/integrations/exploreplugins" element={<ExplorePlugins/>}></Route>
							<Route path="/integrations/gcp-cost-agent" element={<GCPCostAgent/>}></Route>
							<Route path="/integrations/checkov-details" element={<CheckovDetails/>}></Route>
							<Route path="/integrations/kyverno-details" element={<KyvernoDetails/>}></Route>
							<Route path="/integrations/grafana-integration" element={<GrafanaIntegrationPage/>}></Route>
							<Route path="/integrations/grafana" element={<Grafana/>}></Route>
							<Route path="/integrations/prometheus" element={<Prometheus/>}></Route>
							<Route path="/integrations/mirroring-app" element={<MirroringAppDetails/>}></Route>
							<Route path="/integrations/sonarqube" element={<SonarQube/>}></Route>
							<Route path="/integrations/custom-api-catalogue" element={<CustomAPICatalogue/>}></Route>
							<Route path="/finops-dashboard" element={<CostDashboard/>}></Route>
							<Route path="/observability-dashboard" element={<Grafana/>}></Route>
						</Route>

						<Route element={<PrivateRoutes roles={["idp_admin","infrastructure_admin","cluster_owner","application_owner","developer", "viewer"]} />}>
							<Route path="/datasolutions/data-pipelines" element={<DataPipelines />} />
							<Route path="/datasolutions/data-pipelines/add" element={<AddDataPipelinePage isEdit={false} />} />
							<Route path="/datasolutions/data-pipelines/edit/:id" element={<AddDataPipelinePage isEdit={true} />} />
							<Route path="/datasolutions/data-warehouses" element={<DataWarehouses />} />
							<Route path="/datasolutions/data-warehouses/add" element={<DataWarehousesForm isEdit={false} />} />
							<Route path="/datasolutions/data-warehouses/edit/:id" element={<DataWarehousesForm isEdit={true} />} />
							<Route path="/datasolutions/data-warehouses/details/:id" element={<DataWarehousesDetailsPage/>} />
							<Route path="/datasolutions/requests/data-warehouses" element={<DataWarehousesRequestsPage/>} />
							<Route path="/datasolutions/requests/data-warehouses/:id" element={<DataWarehousesApproveFormPage/>} />
							<Route path="/datasolutions/data-bi" element={<DataBI />} />
							<Route path="/datasolutions/data-bi/add" element={<DataBIForm isEdit={false} />} />
							<Route path="/datasolutions/data-bi/details/:id" element={<DataBIDetailsPage/>} />
							<Route path="/datasolutions/data-bi/edit/:id" element={<DataBIForm isEdit={true} />} />
							<Route path="/datasolutions/requests/data-bi" element={<DataBIRequestsPage/>} />
							<Route path="/datasolutions/requests/data-bi/:id" element={<DataBIApproveFormPage/>} />
							<Route path="/datasolutions/requests/data-pipelines" element={<DataPipelineRequestsPage />} />
							<Route path="/datasolutions/requests/data-pipelines/:id" element={<DataPipelineApproveFormPage/>}></Route>
							<Route path="/datasolutions/data-pipelines/details/:id" element={<DataPipelineDetailsPage/>}></Route>
							<Route path="/datasolutions/data-sources" element={<DataSources />} />
                            <Route path="/datasolutions/data-sources/add" element={<AddDataSourcesPage isEdit={false} />} />
                            <Route path="/datasolutions/data-sources/edit/:id" element={<AddDataSourcesPage isEdit={true} />} />
                            <Route path="/datasolutions/data-sources/details/:id" element={<DataSourcesDetailsPage />} />
                            <Route path="/datasolutions/requests/data-sources" element={<DataSourcesRequestsPage />} />
                            <Route path="/datasolutions/requests/data-sources/:id" element={<DataSourcesApproveFormPage />} />

							<Route path="/datasolutions/data-lakes" element={<DataLakes />} />
							<Route path="/datasolutions/data-lakes/add" element={<AddDataLakesPage isEdit={false} />} />
							<Route path="/datasolutions/data-lakes/edit/:id" element={<AddDataLakesPage isEdit={true} />} />
							<Route path="/datasolutions/data-lakes/details/:id" element={<DataLakesDetailsPage />} />
							<Route path="/datasolutions/requests/data-lakes" element={<DataLakesRequestsPage />} />
							<Route path="/datasolutions/requests/data-lakes/:id" element={<DataLakesApproveFormPage />} />

							<Route path="/datasolutions/data-scans" element={<DataScans />} />
    <Route path="/datasolutions/data-scans/add" element={<DataScansForm isEdit={false} />} />
    <Route path="/datasolutions/data-scans/edit/:id" element={<DataScansForm isEdit={true} />} />
    <Route path="/datasolutions/data-scans/details/:id" element={<DataScansDetails />} />
    <Route path="/datasolutions/requests/data-scans" element={<DataScansRequests />} />
    <Route path="/datasolutions/requests/data-scans/:id" element={<DataScansApproverPage />} />

							<Route path="/datasolutions/data-zones" element={<DataZones />} />
							<Route path="/datasolutions/data-zones/add" element={<AddDataZonesPage isEdit={false} />} />
							<Route path="/datasolutions/data-zones/edit/:id" element={<AddDataZonesPage isEdit={true} />} />
							<Route path="/datasolutions/data-zones/details/:id" element={<DataZonesDetailsPage />} />
							<Route path="/datasolutions/requests/data-zones" element={<DataZonesRequestsPage />} />
							<Route path="/datasolutions/requests/data-zones/:id" element={<DataZonesApproveFormPage />} />
							<Route path="/datasolutions/data-bi/add" element={<DataBIForm isEdit={false} />} />
							<Route path="/datasolutions/data-bi/details/:id" element={<DataBIDetailsPage/>} />
							<Route path="/datasolutions/data-bi/edit/:id" element={<DataBIForm isEdit={true} />} />
							<Route path="/datasolutions/requests/data-bi" element={<DataBIRequestsPage/>} />
							<Route path="/datasolutions/requests/data-bi/:id" element={<DataBIApproveFormPage/>} />
						</Route>
						
						<Route element={<PrivateRoutes roles={["idp_admin","infrastructure_admin","application_owner","developer", "viewer"]} />}>
							<Route path="/apis/add/:serviceType" element={<APIRequesterForm isEdit={false} />} />
							<Route path="/apis/add/existing" element={<AddExistingAPIForm />} />
							<Route path="/apis/edit/:id" element={<APIRequesterForm isEdit={true} />} />
							<Route path="/apis/details/:id" element={<APIDetailsPage />} />
							<Route path="/apis" element={<APIPage />} />
							<Route path="/apis/requests" element={<APIRequestsPage/>}></Route>
							<Route path="/apis/requests/details/:id" element={<APIApproveFormPage/>}></Route>

							<Route path="/apis-gateway" element={<APIGatewayPage />} />
							<Route path="/apis-gateway/add/:apiGatewayOption" element={<APIGatewayForm isEdit={false} />} />
							<Route path="/apis-gateway/edit/:id" element={<APIGatewayForm isEdit={true} />} />
							<Route path="/apis-gateway/details/:id" element={<APIGatewayDetailsPage />} />
							<Route path="/apis-gateway/requests" element={<APIGatewayRequestsPage/>}></Route>
							<Route path="/apis-gateway/requests/details/:id" element={<APIGatewayApproveFormPage/>}></Route>
							<Route path="/apis-gateway/add-to-existing" element={<APIGatewayForm isEdit={false} isAddToExisting={true} />} />

							<Route path="/consumer-group" element={<ConsumerGroupPage />} />
							<Route path="/consumer-group/details/:id" element={<ConsumerGroupDetailsPage />} />
							<Route path="/consumer-group/add" element={<ConsumerGroupForm isEdit={false} />} />
							<Route path="/consumer-group/requests" element={<ConsumerGroupRequestsPage/>}></Route>
							<Route path="/consumer-group/requests/details/:id" element={<ConsumerGroupApproveFormPage/>}></Route>
							
						</Route>
						<Route element={<PrivateRoutes roles={["cluster_owner", "viewer"]} />}>
							<Route path="/clusters/add" element={<ClusterForm isEdit={false} />} />
							<Route path="/clusters/add/existing" element={<ExistingClusterForm isEdit={false} />} />
							<Route path="/clusters/aws/add" element={<AWSClusterForm isEdit={false} />} />
						</Route>
						<Route element={<PrivateRoutes roles={["application_owner", "idp_admin", "viewer"]} />}>
							<Route
								path="/applications/add"
								element={<ApplicationRequesterForm isEdit={false} />}
							/>
							<Route
								path="/applications/add/nonK8s"
								element={<NonK8sApplicationRequesterForm isEdit={false} />}
							/>
						</Route>
						<Route element={<PrivateRoutes roles={["infrastructure_admin", "idp_admin", "viewer"]} />}>
							<Route path="/requests/clusters" element={<ClusterRequestsPage />} />
						</Route>
						<Route element={<PrivateRoutes roles={["infrastructure_admin", "idp_admin", "viewer"]} />}>
							<Route path="/requests/applications" element={<ApplicationRequestsPage />} />
						</Route>
						<Route element={<PrivateRoutes roles={["application_owner", "idp_admin", "viewer"]} />}>
							<Route path="/requests/services" element={<ServiceRequestsPage />} />
						</Route>
						<Route element={<PrivateRoutes roles={["infrastructure_admin", "idp_admin", "viewer"]} />}>
							<Route path="/requests/clusters/details/:id" element={<ClusterApproveFormPage />} />
						</Route>
						<Route
							element={
								<PrivateRoutes roles={["cluster_owner", "application_owner", "idp_admin", "viewer"]} />
							}
						>
							<Route path="/clusters/details/:id" element={<ClusterDetailsPage />} />
						</Route>
						<Route element={<PrivateRoutes roles={["cluster_owner", "viewer"]} />}>
							<Route path="/clusters/edit/:id" element={<ClusterForm isEdit={true} />} />
						</Route>
						<Route element={<PrivateRoutes roles={["application_owner", "idp_admin", "viewer"]} />}>
							<Route
								path="/applications/edit/:id"
								element={<ApplicationRequesterForm isEdit={true} />}
							/>
						</Route>
						<Route element={<PrivateRoutes roles={["developer", "idp_admin", "viewer"]} />}>
							<Route
								path="/services/edit/:id"
								element={<ServiceRequesterForm isEdit={true} />}
							/>
						</Route>
						<Route element={<PrivateRoutes roles={["idp_admin", "infrastructure_admin", "viewer"]} />}>
							<Route
								path="/requests/applications/details/:id"
								element={<ApplicationApproveFormPage />}
							/>
						</Route>
						<Route element={<PrivateRoutes roles={["idp_admin", "application_owner", "viewer"]} />}>
							<Route
								path="/requests/services/details/:id"
								element={<ServiceApproveFormPage />}
							/>
						</Route>
						<Route
							element={
								<PrivateRoutes
									roles={["application_owner", "idp_admin", "developer", "cluster_owner", "viewer"]}
								/>
							}
						>
							<Route path="/applications/details/:id" element={<ApplicationDetailsPage />} />
						</Route>
						<Route
							element={<PrivateRoutes roles={["application_owner", "idp_admin", "developer", "viewer"]} />}
						>
							<Route path="/services/details/:id" element={<ServiceDetailsPage />} />
						</Route>

						<Route element={<PrivateRoutes roles={["developer", "idp_admin", "viewer"]} />}>
							<Route
								path="/services/add"
								element={<ServiceRequesterForm isEdit={false} />}
							/>
						</Route>
						
					</Routes>
				</AuthProvider>
			</Router>
		</ThemeProvider>
	);
};

export default App;
